import { Link, Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function Layout() {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-xl font-bold text-foreground">
              Writing Agent
            </Link>
            <div className="flex gap-6">
              <Link
                to="/"
                className={cn(
                  'text-sm font-medium transition-colors hover:text-primary',
                  'text-muted-foreground'
                )}
              >
                Home
              </Link>
              <Link
                to="/chat"
                className={cn(
                  'text-sm font-medium transition-colors hover:text-primary',
                  'text-muted-foreground'
                )}
              >
                Chat
              </Link>
              <Link
                to="/sessions"
                className={cn(
                  'text-sm font-medium transition-colors hover:text-primary',
                  'text-muted-foreground'
                )}
              >
                Sessions
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
